import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "@/layouts/app-layout";
import { DashboardPage } from "@/pages/dashboard-page";
import { ComingSoonPage } from "@/pages/coming-soon-page";
import { CustomersPage, CustomerFormPage } from "@/features/customers/customer-pages";
import { ShipmentDetailPage, ShipmentFormPage, ShipmentsPage } from "@/features/shipments/shipment-pages";
import { LoginPage } from "@/features/auth/login-page";
import { AuthProvider } from "@/features/auth/auth-provider";
import { useAuth } from "@/features/auth/auth-context";
import { ProtectedRoute } from "@/features/auth/protected-route";
import { TenantProvider } from "@/features/auth/use-tenant-context";

function AuthenticatedApplication() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <TenantProvider user={user}>
      <AppLayout />
    </TenantProvider>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AuthenticatedApplication />}>
            <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
            <Route path="/app/dashboard" element={<DashboardPage />} />
            <Route path="/shipments" element={<ShipmentsPage />} />
            <Route path="/shipments/new" element={<ShipmentFormPage />} />
            <Route path="/shipments/:id/edit" element={<ShipmentFormPage />} />
            <Route path="/shipments/:id" element={<ShipmentDetailPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/customers/new" element={<CustomerFormPage />} />
            <Route path="/customers/:id" element={<CustomerFormPage />} />
            <Route path="/app/documents" element={<ComingSoonPage />} />
            <Route path="/app/settings" element={<ComingSoonPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}
